import React, { useState, useRef, useMemo, useEffect } from "react";
import { useClientContext } from '../contexts/ClientContext.js';
import axios from 'axios';
import Dropdown from "./Dropdown.js";
import taiwanRegions from "../data/taiwanRegions.js";
import { api } from "../apiClient.js";

function CreateClient() {
  // const phoneRef = useRef(); // 用於存放 Phone 組件的 ref
  // const addressRef = useRef();
  // const houseRef = useRef();
  const {
    clientData,
    updateClientData,
    clientStatus,
    setClientStatus
  } = useClientContext();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 從 Phone 組件獲取電話數據
    // const phoneData = phoneRef.current.getPhoneData();
    // const addressData = addressRef.current.getAddressData();
    // const houseData = houseRef.current.getHouseData();
    // 收集所有表單數據
    const clientData = {
      house: selectedHouse,
      client_zh: e.target.client_zh.value,
      client_en: e.target.client_en.value,
      client_alias: e.target.client_alias.value,
      tax_no: e.target.tax_no.value,
      phone: `${selectedCode} ${phoneNumber}`,
      address: `${selectedCity}${selectedDistrict}${e.target.detailedAddress.value}`,
      contact_name: e.target.contact_name.value,
      contact_phone: e.target.contact_phone.value,
      contact_email: e.target.contact_email.value,
      date: e.target.date.value,
      payment_terms: e.target.payment_terms.value,
    };

    console.log(clientData);
    // Example output:
    // {
    //   city: "台北市",
    //   district: "中正區",
    //   detailedAddress: "信義路一段100號"
    // }

    // 一次性更新 clientData
    updateClientData(clientData);

    const payload = new FormData();
    payload.append("house", clientData.house);
    payload.append("client_zh", clientData.client_zh);
    payload.append("client_en", clientData.client_en);
    payload.append("client_alias", clientData.client_alias);
    payload.append("tax_no", clientData.tax_no);
    payload.append("phone", clientData.phone);
    payload.append("address", clientData.address);
    payload.append("contact_name", clientData.contact_name);
    payload.append("contact_phone", clientData.contact_phone);
    payload.append("contact_email", clientData.contact_email);
    payload.append("date", clientData.date);
    payload.append("payment_terms", clientData.payment_terms);

    try {
      console.log("payload:", payload)
      // setUploadStatus("上傳中...");
      // const response = await axios.post("http://127.0.0.1:5000/create-client", payload, {
      const response = await api.post("/create-client", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // setUploadStatus("上傳成功！");
      e.target.reset();
      alert("資料已提交");
    } catch (error) {
      console.error("上傳失敗:", error);
      // setUploadStatus("上傳失敗！");
    }
  };

  // 選單選項
  const [houseOptions, setHouseOptions] = useState([
    { value: "一一", label: "一一" },
    { value: "十十", label: "十十" },
  ]);
  const [countryOptions, setCountryOptions] = useState([
    { value: "+886", label: "Taiwan +886" },
    { value: "+852", label: "Hong Kong +852" },
    { value: "+1", label: "United States +1" },
    { value: "+1", label: "Canada +1" },
    { value: "+44", label: "United Kingdom +44" },
    { value: "+81", label: "Japan +81" },
    { value: "+86", label: "China +86" },
    { value: "+61", label: "Australia +61" },
  ]);


  // 下拉選單數據
  const [cityOptions, setCityOptions] = useState(Object.keys(taiwanRegions).map((city) => ({
    value: city,
    label: city,
  })));


  // 狀態管理
  const [selectedHouse, setSelectedHouse] = useState(houseOptions[0].value);
  const [selectedCode, setSelectedCode] = useState(countryOptions[0].value); // Default to Taiwan
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCity, setSelectedCity] = useState(Object.keys(taiwanRegions)[0]); // 縣市
  const [selectedDistrict, setSelectedDistrict] = useState(""); // 鄉鎮市區
  // const [detailedAddress, setDetailedAddress] = useState(""); // 詳細地址

  const districtOptions = useMemo(() => {
    const districts = taiwanRegions[selectedCity];
    return districts ? districts.map(d => ({ value: d, label: d })) : [];
  }, [selectedCity]);


  useEffect(() => {
    if (taiwanRegions[selectedCity] && taiwanRegions[selectedCity].length > 0) {
      const first = taiwanRegions[selectedCity]?.[0] || "";
      setSelectedDistrict(first);
    } else {
      setSelectedDistrict("");
    }
  }, [selectedCity]);

  useEffect(() => {
    console.log("selectedCity:", selectedCity);
  }, [selectedCity]);

  // const districtOptions =
  //   selectedCity && taiwanRegions[selectedCity]
  //     ? taiwanRegions[selectedCity].map((district) => ({
  //       value: district,
  //       label: district,
  //     }))
  //     : [];

  const handleHouseChange = (value) => {
    setSelectedHouse(value);
  };
  const handleCodeChange = (value) => {
    setSelectedCode(value);
  };
  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };



  return (
    <>
        <div className='sidebar-header'>— Client —</div>
      <form
        onSubmit={handleSubmit}
        className='sidebar-form'
      >
        <label className="client-house">
          <img src='./house.png' style={{ width: "6%" }}></img>
          House:
          <Dropdown
            label="House: "
            name="house"
            options={houseOptions}
            value={selectedHouse}
            onChange={handleHouseChange}
            setOptions={setHouseOptions}
            block="client-dropdown-house"
          />
        </label>
        <div className="client-info">
          <div className="blue-block info">
            <img src='./company.png' style={{ width: "7%" }}></img>
            INFO
          </div>
          <label style={{ color: "#ED6737" }}>Client(中):</label>
          <div className="input-wrapper">
            <input type="text" id="client_zh" name="client_zh" placeholder="Enter client" />
          </div>
          <label className="client_en" style={{ color: "#ED6737" }}>Client(英):</label>
          <div className="input-wrapper">
            <input type="text" id="client_en" name="client_en" placeholder="Enter client" />
          </div>
          <label style={{ color: "#ED6737" }}>Client Alias:</label>
          <div className="input-wrapper">
            <input type="text" id="client_alias" name="client_alias" placeholder="Enter client alias" />
          </div>
          <label>
            <img src='./tax.png' style={{ width: "25%" }}></img>
            Tax No:</label>
          <div className="input-wrapper">
            <input type="text" id="tax_no" name="tax_no" placeholder="Enter tax no" />
          </div>
          <label className="phone" htmlFor="contact_phone">
            <img src='./phone.png' style={{ width: "25%" }}></img>
            Phone:
          </label>
          <Dropdown
            label="Phone: "
            name="phone"
            options={countryOptions}
            value={selectedCode}
            onChange={handleCodeChange}
            setOptions={setCountryOptions}
            grid_area="phone1"
          />
          <div className="phone2 input-wrapper">
            <input
              type="tel"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              placeholder="Enter phone number"
            />
          </div>
          {/* <AddressInput ref={addressRef} /> */}

          <label className="address" htmlFor="contact_phone">
            <img src='./location.png' style={{ width: "25%" }}></img>
            Address:</label>
          <Dropdown
            label="Address: "
            name="city"
            options={cityOptions}
            value={selectedCity}
            onChange={(option) => {
              setSelectedCity(option.value);
              // setSelectedDistrict(""); // 城市更改時清空區域
            }}
            setOptions={setCityOptions}
            grid_area="address1"
          />
          <Dropdown
            name="district"
            options={districtOptions}
            value={selectedDistrict}
            onChange={(value) => setSelectedDistrict(value)}
            // disabled={!selectedCity} // 未選擇城市時禁用
            grid_area="address2"
          />
          <div className="address3 input-wrapper">
            <input
              className="address3"
              type="text" id="detailedAddress" name="detailedAddress"
              // onChange={(e) => setDetailedAddress(e.target.value)}
              placeholder="Enter detailed address"
            /></div>
        </div>

        <div className="client-contact">
          <div className="blue-block contact">
            <img src='./DM.png' style={{ width: "7%" }}></img>
            Contact
          </div>
          <label className="name" htmlFor="contact_name">
            <img src='./name.png' style={{ width: "25%" }}></img>
            Name:
          </label>
          <div className="input-wrapper">
            <input type="text" id="contact_name" name="contact_name" placeholder="Enter contact name" />
          </div>
          <label className="phone" htmlFor="contact_phone">
            <img src='./phone.png' style={{ width: "25%" }}></img>
            Phone:
          </label>
          <div className="input-wrapper">
            <input type="tel" id="contact_phone" name="contact_phone" placeholder="Enter contact phone" />
          </div>
          <label className="email" htmlFor="contact_email">
            <img src='./email.png' style={{ width: "25%" }}></img>
            Email:</label>
          <div className="input-wrapper">
            <input type="email" id="contact_email" name="contact_email" placeholder="Enter contact email" />
          </div>
        </div>

        <div className="client-note">
          <label>
            <img src='./date.png' style={{ width: "20%" }}></img>
            Date:
          </label>
          <div className="input-wrapper">
            <input type="date" id="date" name="date" placeholder="Enter date" />

          </div>
          <label className="payment" htmlFor="payment_terms">
            <img src='./money.png' style={{ width: "20%" }}></img>
            Payment Terms:
          </label>
          <div className="input-wrapper">
            <input type="text" id="payment_terms" name="payment_terms" placeholder="Enter payment terms" />

          </div>
        </div>
        <button className="orange-button" type="submit">
          <img src='./arrow03.png' style={{ width: "30%" }}></img>
          Submit
          </button>
      </form>
    </>
  )
}

export default CreateClient;
